var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75366 10.4309L6.78157 9.7066L4.25687 6.64723L2.75366 10.4309ZM4.68221 6.29875L7.21375 9.353L13.2761 4.37875L10.7463 1.3245L4.68221 6.29875ZM14.8084 2.17006L13.2266 0.258594C12.9686 -0.0557129 12.4801 -0.0881685 12.1385 0.18685L11.2177 0.938454L13.7476 3.99782L14.6683 3.24622C15.0031 2.9712 15.0663 2.48437 14.8084 2.17006Z",
    fill: "#2867CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5986 13.0002H2.8783C1.28798 13.0002 0 11.7105 0 10.1219V3.63416C0 2.04383 1.28968 0.755859 2.8783 0.755859H3.72556C4.17994 0.755859 4.5472 1.12312 4.5472 1.5775C4.5472 2.03188 4.17994 2.39914 3.72556 2.39914H2.8783C2.19502 2.39914 1.64157 2.95259 1.64157 3.63587V10.1236C1.64157 10.8069 2.19502 11.3603 2.8783 11.3603H11.5986C12.2819 11.3603 12.8353 10.8069 12.8353 10.1236V7.86876C12.8353 7.41439 13.2026 7.04712 13.657 7.04712C14.1114 7.04712 14.4786 7.41439 14.4786 7.86876V10.1236C14.4769 11.7122 13.1889 13.0002 11.5986 13.0002Z",
    fill: "#BDD2EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSummaryIcon);
export default __webpack_public_path__ + "static/media/editSummaryIcon.1b26b505b6be57e3b65c1f68316d5113.svg";
export { ForwardRef as ReactComponent };